module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.8@readable-stream/writable-browser.js
// module id = 772
// module chunks = 0